import { createContext, useContext } from 'react';
import { MESSAGES, type Language, type MessageKey } from './lib/i18n.ts';

export type Role = 'owner' | 'viewer';

export interface AppContextValue {
  readonly language: Language;
  readonly role: Role;
  readonly t: (key: MessageKey) => string;
}

export const AppContext = createContext<AppContextValue | null>(null);

export function useApp(): AppContextValue {
  const value = useContext(AppContext);
  if (value === null) throw new Error('useApp must be used inside AppContext');
  return value;
}

export function translator(language: Language): (key: MessageKey) => string {
  return (key) => MESSAGES[language][key];
}
